/*
* Deliverables component specific for Adalia M&E.
* 
* Project can be passed as a prop, but if not, this component expects a project-id context. Rendering without causes an error.
* 
*/
import React from 'react';

import {resolveComponentProps} from '../form_viewer.jsx';
import {fetchJson} from '../../../helpers/fetch.js';

import {
  Mode,
  DataType,
  NumericalValidationLimits,
  castDataType,
} from '../common.jsx';
import Helpers from './helpers.jsx';
import Setting from './setting.jsx';

import GridLayout from './grid_layout.jsx';
import DropdownSelectionWithAsyncOptions from './dropdown_selection_with_async_options.jsx';
import RepeatableRegion from './repeatable_region.jsx';
import TextField from './text_field.jsx';
import Resolver from '../component_resolver.jsx'

import { project_deliverable_grouped_options_for_select_path } from '~/routes';

export default class AdaliaMEDeliverables extends GridLayout {

  static get CATEGORY() {
    return 'question';
  }

  static get TYPE() {
    return 'adalia_me_deliverables';
  }

  static icon() {
    return <i className='fa fa-tasks'></i>;
  }

  constructor(props) {
    super(props);
    this.addRow = this.addRow.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.addColumn = this.addColumn.bind(this);
    this.deleteColumn = this.deleteColumn.bind(this);
    this.reorderOption = this.reorderOption.bind(this);
    this.state = {
      //order: [...props?.content?.rows?.keys() || []]
    }
  }

  static defaultContent(language) {
    let fieldName = 'field_' + Helpers.randomString();

    let repeatableDeliverableRegionContent = Object.assign(AdaliaMERepeatableDeliverableRegion.defaultContent(language), {
      name: fieldName + '_repeatable_deliverable_region',
      dependentOptions: fieldName + '_dropdown',
      deletable: false,
      sortable: false,
      allowMultiple: true,
    });

    return Object.assign(super.defaultContent(language), {
      level: 'project',
      name: fieldName,
      rows: [
        [
          {
            span: 1,
            component: Object.assign(AdaliaMEDeliverablesSelector.defaultContent(language), {
              name: fieldName + '_dropdown',
              deletable: false,
              sortable: false,
              allowMultiple: true,
            })
          }
        ],
        [
          {
            span: 1,
            component: repeatableDeliverableRegionContent,
          }
        ]
      ]
    });
  }

  componentDidMount() {
    super.componentDidMount();

    if (typeof this.props.updateSettingsCallback == 'function') {
      let content = this.props.content;
      if (content.isNewComponent) {
        content.rows[0][0].component.isNewComponent = true;
        this.props.updateSettingsCallback(content.id, content, true);
      }
    }
  }

  renderSettings() {
    return <></>
  }
}


export class AdaliaMEDeliverablesSelector extends DropdownSelectionWithAsyncOptions {

  static get TYPE() {
    return 'adalia_me_deliverables_selector';
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: 'field_choose_deliverables_default_label',
      description: 'field_default_description',
      help: null,
    };
  }

  static get SETTINGS_DUMMY_DATA() {
    return [
      {
        value: 1, label: 'Milestone 1',
        options: [
          {value: 1, label: 'Deliverable 1.1', status: '', parent_id: 1},
          {value: 2, label: 'Deliverable 1.2', status: '', parent_id: 1}
        ]
      },
      {
        value: 2, label: 'Milestone 2',
        options: [{value: 3, label: 'Deliverable 2.1', status: '', parent_id: 2}]
      },
      {
        value: 3, label: 'Milestone 3',
        options: [{value: 4, label: 'Deliverable 3.1', status: '', parent_id: 3}]
      },
    ];
  }

  static dropAllowed(dropArea, droppedContent, components, isNested) {
    return false
  }

  static defaultContent(language) {
    return Object.assign(super.defaultContent(language), {
      deletable: false,
      sortable: false,
      allowMultiple: true,
      reportKey: '',
      dataType: DataType.INTEGER
    });
  }

  componentDidMount() {
    super.componentDidMount();

    let projectId = this.context?.projectId;

    if (!projectId || [Mode.EDIT, Mode.SETTINGS].includes(this.props.mode)) {
      let allOptions = this.constructor.SETTINGS_DUMMY_DATA;
      let options = this.props.content.allowSelectingDeliverables ? allOptions : allOptions.map((v) => _.omit(v, 'options'));

      this.setState({
        options: options,
        allOptions: allOptions,
        loading: false
      });
    } else {
      fetchGroupedOptionsForSelect(
        projectId,
        this.getAnswer(),
        this.props.handleDisbursement,
        (res) => {
          if (res) {
            let allOptions = res;
            let options = this.props.content.allowSelectingDeliverables ? allOptions : allOptions.map((v) => _.omit(v, 'options'));

            this.setState({
              allOptions: res,
              options: options,
              loading: false
            })
          }
        });
    }
  }

  onChange = (value) => {
    var values = value.map((v) => {
      var data = [];

      if (this.props.content.allowSelectingDeliverables) {
        let deliverable = this.state.options.map((o) => o.options).flat().find((o) => o.value == v);
        let milestone = this.state.options.find((o) => o.value == deliverable.parent_id);
        data = [this.getFormattedValues(deliverable, milestone)];

      } else {
        let milestone = this.state.options.find((o) => o.value == v);
        let deliverables = this.state.allOptions.find((o) => o.value == v).options.filter((v) => !v.disabled);
        data = deliverables.map((d) => this.getFormattedValues(d, milestone))
      }

      return (data)
    }).flat();

    jQuery(this.refs.root).attr('data-items', JSON.stringify(values));
    this.updateAnswer(value);
  };

  getFormattedValues(deliverable, milestone) {
    return ({
      deliverable_id: deliverable.value,
      deliverable_title: deliverable.label,
      milestone_id: milestone.value,
      milestone_title: milestone.label
    })
  }

  componentDidUpdate(prevProps, prevState) {
    super.componentDidUpdate();
  }

  renderSettings() {
    return <div>
      <Setting.TextField name='label' label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings} />
      <Setting.Checkbox name='label_hidden' className='label-hidden-check' label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings} />
      <Setting.LongTextField name="description" label={I18n.t('field_description', {scope: 'fe'})} value={this.getText('description')} onChange={this.updateSettings} />
      <Setting.LongTextField name="help" label={I18n.t('field_help', {scope: 'fe'})} value={this.getText('help')} onChange={this.updateSettings} />
      <Setting.TextField
        name="reportKey"
        label={I18n.t('field_report_key', {scope: 'fe'})}
        value={this.props.content.reportKey}
        description={I18n.t('field_report_key_description', {scope: 'fe'})}
        {...(this.allowModifyInSafeMode ? {onChange: this.updateSettings} : {disabled: true})}
      />
      <Setting.Checkbox name='allowSelectingDeliverables' value={this.props.content.allowSelectingDeliverables} onChange={this.updateSettings} label={I18n.t('field_allow_selecting_deliverables', {scope: 'fe'})} description={''} />
    </div>
  }

  beforeUpdateSettings(content) {
    super.beforeUpdateSettings(content);
    content.allowSelectingDeliverables = castDataType(content.allowSelectingDeliverables, DataType.BOOLEAN);
  }
}


export class AdaliaMERepeatableDeliverableRegion extends RepeatableRegion {

  static get TYPE() {
    return 'adalia_me_repeatable_deliverable_region';
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: 'field_deliverables_default_label'
    };
  }

  // Can be dependent on the selector selection
  static resolveRelatedAnswerNamesOrIds(content, repeatedFieldScope = "") {
    let names = [];
    if (content.name) {
      names.push(repeatedFieldScope + "[" + content.name + "]");
    }
    let dependentOptions = content.dependentOptions ? ['[' + content.dependentOptions + ']'] : [];
    return [...dependentOptions, ...names];
  }

  static defaultContent(language) {
    return Object.assign(super.defaultContent(language), {
      component: {
        ...Object.assign(GridLayout.defaultContent(language), {
          deletable: false,
          cloneable: false
        }),
        rows: [
          [{ span: 1, component: null }]
        ],
      },
    });
  }

  componentDidUpdate(prevProps, prevState) {
    var selector_data_changed = jQuery(this.refs.root)
      .closest('.' + AdaliaMEDeliverables.TYPE)
      .find('.' + AdaliaMEDeliverablesSelector.TYPE).attr('data-items');

    if(selector_data_changed) {
      var items = $.parseJSON(selector_data_changed);

      if (this.props.mode == Mode.FILL && this.state.rows.length != items.length) {

        var rows = this.state.rows || [];

        if(this.state.rows.length < items.length) {
          for (let i = this.state.rows.length; i < items.length; i++) {
            let item = items[i];
            let newRowId = 'row-' + item.deliverable_id;
            rows.push(newRowId);
            this.props.updateAnswerCallback(this.props.content.name + '[' + newRowId + ']', {deleted: false, ...item});
          }
          this.setState({
            rows: rows
          });

        } else if(this.state.rows.length > items.length) {
          let rowIds = _.difference(this.state.rows, items.map((v) => `row-${v.deliverable_id}`));

          rowIds.forEach((rowId) => {
            let rowIndex = this.state.rows.indexOf(rowId);
            rows.splice(rowIndex, 1);
            this.props.updateAnswerCallback(this.props.content.name + '[' + rowId + ']', {deleted: true});
          });

          this.setState({
            rows: rows
          });
        }
      }
    }
    super.componentDidUpdate();
  }

  constructor(props) {
    super(props);

    let rows = [];
    let answer = ((this.props.answers || {})[(this.props.content || {}).name] || {});

    // Initial the number of rows added to answers
    if (this.inEditMode) {
      rows.push('row-0');
    } else {
      rows = Object.keys(answer).filter(k => k != 'row_count');
    }

    this.state = {
      rows: rows,
      options: []
    };
  }

  renderView() {
    var rows = [];
    var project = this.props.project;
    var projectId = this.context?.projectId;

    this.state.rows.forEach((rowId, i) => {
      let component = null;
      let fieldName = `${this.fullFieldName()}[${rowId}]`;
      let answer = ((this.props.answers || {})[this.props.content.name]||{})[rowId] || {};

      if (this.props.content.component) {
        if ((this.inEditMode || this.props.content.provideIndicativePercentageReached) && this.props.content.component.rows.length == 1)   {
          this.props.content.component.rows.push([{
            span: 1,
            component: Object.assign(AdaliaMEIndicativePercentageReached.defaultContent(this.props.language), {name: `indicative_percentage_reached`, deletable: false, sortable: false})
          }])
        } else if ((!this.inEditMode && !this.props.content.provideIndicativePercentageReached) && this.props.content.component.rows.length > 1) {
          this.props.content.component.rows.pop()
        }

        component = Resolver.createElement(
          this.props.content.component.type,
          resolveComponentProps(this.props.content.component, this.props, {
            selectCallback: this.props.selectCallback,
            selectedId: this.props.selectedId,
            repeatedFieldScope: this.props.content.name + "[" + rowId + "]",
            repeatedFieldRowIndex: i,
            project: project,
            readOnly: project?.report_approved,
            // Provide only prefill answers relevant for project
            prefillAnswers: (this.props.prefillAnswers || {})[projectId] || {},
            prefillAttachments: (this.props.prefillAttachments || {})[projectId] || {}
          })
        );
      } else if (this.inEditMode) {
        component = <Helpers.DropArea componentId={this.props.content.id} />;
      }

      rows.push(
        <div key={rowId} className='component-row' style={{display: 'block'}}>
          <div className='mb-2'>
            { this.inEditMode ? "<Milestone Title> - <Deliverable Title>" : `${answer['milestone_title']} - ${answer['deliverable_title']}`}
          </div>

          <div className='component'>
            {component}
          </div>

          {!this.inEditMode && (
            <>
              <input type="hidden" name={`${fieldName}][deliverable_id]`} value={answer['deliverable_id']}/>
              <input type="hidden" name={`${fieldName}][deliverable_title]`} value={answer['deliverable_title']}/>
              <input type="hidden" name={`${fieldName}][milestone_id]`} value={answer['milestone_id']}/>
              <input type="hidden" name={`${fieldName}][milestone_title]`} value={answer['milestone_title']}/>
            </>
          )}
        </div>
      );
    });

    return (
      <div>
        {rows.length > 0 &&
          <>
            <label className='mb-1'>{this.getText('label')}</label>
            {rows}
          </>
        }
        <input type='hidden' name={this.fullFieldName() + '[row_count]'} defaultValue={rows.length} />
      </div>
    );
  }

  renderSettings() {
    return <div>
      <Setting.TextField name='label' label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings} />
      <Setting.Checkbox name='provideIndicativePercentageReached' value={this.props.content.provideIndicativePercentageReached} onChange={this.updateSettings} label={I18n.t('field_allow_providing_indicative_percentage_reachederables', {scope: 'fe'})} description={''} />
    </div>;
  }

  beforeUpdateSettings(content) {
    super.beforeUpdateSettings(content);
    content.provideIndicativePercentageReached = castDataType(content.provideIndicativePercentageReached, DataType.BOOLEAN);
  }
}


const fetchGroupedOptionsForSelect = (project_id, selected, handlingEnabled, cb) => {
  fetchJson(project_deliverable_grouped_options_for_select_path({ project_id: project_id })).then(
    (res) => {
      cb(res.map(p => ({ ...p })));
    }
  )
};


export class AdaliaMEIndicativePercentageReached extends TextField {
  static get TYPE() {
    return 'adalia_me_indicative_percentage_reached';
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: 'field_default_indicative_percentage_reached_label',
      description: '',
      placeholder: '',
      help: null,
      unit: '%',
    };
  }

  static defaultContent(language) {
    return Object.assign(super.defaultContent(language), {
      reportKey: '',
      unit: null,
      help: null,
      dataType: DataType.INTEGER,
      deletable: false,
      cloneable: false,
      validations: {dataType: DataType.INTEGER}
    });
  }

  renderSettings() {
    let validations = this.props.content.validations || {};

    return <>
      <Setting.TextField name="label" label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings} />
      <Setting.TextField name="placeholder" label={I18n.t('field_placeholder', {scope: 'fe'})} value={this.getText('placeholder')} onChange={this.updateSettings} />
      <Setting.LongTextField name="description" label={I18n.t('field_description', {scope: 'fe'})} value={this.getText('description')} onChange={this.updateSettings} />
      <Setting.LongTextField name="help" label={I18n.t('field_help', {scope: 'fe'})} value={this.getText('help')} onChange={this.updateSettings} />

      <div className="setting">
        <label>
          {I18n.t('validate_range', {scope: 'fe'})}
        </label>
        <div className="validation-range">
          <div className="value">
            <input type="text" ref="validateMin" name="validateMin" className="form-control" defaultValue={validations.min} placeholder={I18n.t('validation_min', {scope: 'fe'})} onKeyUp={this.updateSettings} onBlur={(e)=> {this.props.content.dataType == DataType.DATE && this.updateSettings(e)}} autoComplete={this.getAutoComplete()} />
          </div>
          <div className="dash">
           &mdash;
          </div>
          <div className="value">
            <input type="text" ref="validateMax" name="validateMax" className="form-control" defaultValue={validations.max} placeholder={I18n.t('validation_max', {scope: 'fe'})} onKeyUp={this.updateSettings} onBlur={(e)=> {this.props.content.dataType == DataType.DATE && this.updateSettings(e)}} autoComplete={this.getAutoComplete()} />
          </div>
        </div>
      </div>

      <Setting.TextField
        name="reportKey"
        label={I18n.t('field_report_key', {scope: 'fe'})}
        value={this.props.content.reportKey}
        description={I18n.t('field_report_key_description', {scope: 'fe'})}
        {...(this.allowModifyInSafeMode ? {onChange: this.updateSettings} : {disabled: true})}
      />
    </>
  }

  beforeUpdateSettings(content) {
    content.validations = {};
    content.dataType = DataType.INTEGER;

    if ((content.validateMin || '').length > 0) {
      content.validations.min = castDataType(content.validateMin < NumericalValidationLimits.MIN ? NumericalValidationLimits.MIN : content.validateMin, content.dataType);
    }
    if ((content.validateMax || '').length > 0) {
      content.validations.max = castDataType(content.validateMax > NumericalValidationLimits.MAX ? NumericalValidationLimits.MAX : content.validateMax, content.dataType);
    }
  }
}
